import styled, { keyframes } from 'styled-components';
import { Input, DatePicker } from 'antd';

const pulseAnimation = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 4px 0;
`;

export const IconWrapper = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  
  .anticon {
    font-size: 18px;
    color: white;
    animation: ${pulseAnimation} 2s ease-in-out infinite;
  }
`;

export const Title = styled.h2`
  margin: 0 0 4px 0;
  font-size: 17px;
  font-weight: 700;
  color: #1a1a2e;
  text-align: center;
`;

export const Subtitle = styled.p`
  margin: 0 0 16px 0;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.65);
  text-align: center;
  max-width: 280px;
  line-height: 1.4;
`;

export const FormSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 16px;
`;

export const FormField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Label = styled.label`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
  
  .anticon {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.45);
  }
`;

export const StyledInput = styled(Input)`
  height: 34px;
  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  font-size: 13px;
  transition: all 0.2s ease;
  
  &:hover {
    border-color: rgba(22, 119, 255, 0.4);
  }
  
  &:focus, &.ant-input-focused {
    border-color: #1677ff;
    box-shadow: 0 0 0 2px rgba(22, 119, 255, 0.1);
  }
  
  &::placeholder {
    color: rgba(0, 0, 0, 0.35);
  }
`;

export const StyledDatePicker = styled(DatePicker)`
  height: 34px;
  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  font-size: 13px;
  transition: all 0.2s ease;
  
  &:hover {
    border-color: rgba(22, 119, 255, 0.4);
  }
  
  &:focus, &.ant-picker-focused {
    border-color: #1677ff;
    box-shadow: 0 0 0 2px rgba(22, 119, 255, 0.1);
  }
  
  .ant-picker-input > input::placeholder {
    color: rgba(0, 0, 0, 0.35);
  }
`;

export const ButtonSection = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
  margin-top: 4px;
  
  button {
    flex: 1;
    height: 36px;
    font-size: 13px;
    font-weight: 600;
  }
`;

export const FieldHint = styled.span`
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
  margin-top: -4px;
`;
